<template>
    <div>
        <!-- DATA TABLE Paket yg sudah di-approve -->
        <v-container>
            <v-data-table
                class="elevation-1"
                :headers="table.headers"
                :items="table.items"
                :items-per-page="10"
                :single-select="true"
                item-key="id"
            >
                <template v-slot:item.status="{item}">
                    <v-chip v-if="item.status === 'D1'" color="red">Draft</v-chip>
                    <v-chip v-else-if="item.status === 'T0'" color="yellow">Proses Non-Tender</v-chip>
                    <v-chip v-else-if="item.status === 'T1'" color="blue">Proses Tender</v-chip>
                    <v-chip v-else-if="item.status === 'TS'" color="green">Tender Selesai</v-chip>
                </template>
                <template v-slot:item.actions="{item}">
                    <v-btn v-if="item.status === 'A0'" color="blue" depressed small @click="openForm(item, false)">Buat Tender / Non-Tender</v-btn>
                    <v-btn v-if="item.status === 'D1' || item.status === 'T0' || item.status === 'T1' || item.status === 'TS'" color="blue" small icon @click="openForm(item, true)"> <v-icon small class="mr-2">mdi-file</v-icon> </v-btn>
                    <v-btn v-if="item.status === 'D1'" color="cyan" small icon @click="openForm(item, false)"> <v-icon small class="mr-2">mdi-pencil</v-icon> </v-btn>
                    <v-btn v-if="item.status === 'D1'" color="red" small icon @click="deleteConfirmation(item)"> <v-icon small>mdi-delete</v-icon> </v-btn>
                </template>
            </v-data-table>

            <!-- DELETE ALERT -->
            <v-dialog v-model="form.isDeleting" max-width="600" persistent>  
                <v-alert type="error">
                    <v-row>
                        <v-col class="grow">Anda yakin ingin menghapus draft tender? </v-col>
                    </v-row>
                    <v-row>
                        <v-col class="shrink" @click="closeForm()"> <v-btn>No</v-btn> </v-col>
                        <v-col class="shrink" @click="submitForm(false)"> <v-btn>Yes</v-btn> </v-col>
                    </v-row>
                </v-alert>
            </v-dialog>

        </v-container>


        <!-- FORM -->
        <v-dialog v-model="form.isShowing" max-width="1000" persistent>
        <v-form ref="form" v-model="form.isValid" lazy-validation>
            <v-card>
                <v-container>

                    <!-- INFO TENDER -->
                    <v-row dense> 
                        <v-col> <v-text-field v-model="form.tender.id" label="Kode Tender" readonly /> </v-col>
                        </v-row>
                    <v-row dense> 
                        <v-col> <v-text-field v-model="form.tender.nama" label="Nama Tender" readonly /> </v-col>
                    </v-row>
                    <v-row dense> 
                        <v-col cols="6"> <v-autocomplete v-model="form.tender.jenisKontrak" :items="selectionJenisKontrak" label="Jenis Kontrak" readonly /> </v-col> 
                    </v-row>


                    <!-- PAKET -->
                    <v-row class="blue-grey" dense>
                        <v-col cols="2"> <v-subheader>Kode Paket</v-subheader> </v-col>
                        <v-col> <v-subheader>Nama Paket</v-subheader> </v-col>
                    </v-row>
                    <v-row v-for="(paket, i) in form.tender.listPaket" :key="'paket' + i" align="center" dense>
                        <v-col cols="2"> <v-text-field v-model="paket.id" readonly /> </v-col>
                        <v-col cols="9"> <v-text-field v-model="paket.nama" readonly /> </v-col>
                    </v-row>


                    <!-- DANA -->
                    <v-row class="blue-grey" dense>
                        <v-col> <v-subheader>Sumber Dana</v-subheader> </v-col>
                        <v-col> <v-subheader>Asal Dana</v-subheader> </v-col>
                        <v-col> <v-subheader>MAK</v-subheader> </v-col>
                        <v-col> <v-subheader>Pagu</v-subheader> </v-col>
                    </v-row>
                    <v-row v-for="(dana, i) in form.ListSumberDana" :key="'dana' + i" align="center" dense>
                        <v-col> <v-text-field :value="GetSumberDanaCap(dana.fk_sumberDanaId)" readonly /> </v-col>
                        <!-- <v-col> <v-text-field v-model="dana.sumberDana" readonly /> </v-col> -->
                        <v-col> <v-text-field v-model="dana.asalDana" readonly /> </v-col>
                        <v-col> <v-text-field v-model="dana.mak" readonly /> </v-col>
                        <v-col> <v-text-field v-model="dana.pagu" readonly /> </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="9"></v-col>
                        <v-col> <v-text-field v-model="form.totalPagu" label="Total Pagu" outlined readonly /> </v-col>
                    </v-row>


                    <!-- LOKASI PEKERJAAN -->
                    <v-row class="blue-grey" dense>
                        <v-col> <v-subheader>Provinsi</v-subheader> </v-col>
                        <v-col> <v-subheader>Kota/Kabupaten</v-subheader> </v-col>
                        <v-col> <v-subheader>Detail</v-subheader> </v-col>
                    </v-row>
                    <v-row v-for="(lokasi, i) in form.ListLokasiKerja" :key="'lokasi' + i" align="center" dense>
                        <!-- <v-col> <v-text-field v-model="lokasi.provinsi" readonly /> </v-col>
                        <v-col> <v-text-field v-model="lokasi.kotaKabupaten" readonly /> </v-col> -->
                        <v-col> <v-text-field :value="GetProvinsiCap(lokasi.fk_kotaKabupatenId)" readonly /> </v-col>
                    <v-col> <v-text-field :value="GetKotaCap(lokasi.fk_kotaKabupatenId)" readonly /> </v-col>
                        <v-col> <v-text-field v-model="lokasi.detail" readonly /> </v-col>
                    </v-row>


                    <!-- DOKUMEN -->
                    <v-row class="blue-grey" dense> <v-col> <v-subheader>Dokumen</v-subheader> </v-col> </v-row>

                    <!-- File HPS -->
                    <v-row dense>
                        <v-col v-if="form.tender.fileHPS === ''" align-self="center" cols="4"> <span class="red--text">* HPS belum dilampirkan</span> </v-col>
                        <v-col v-else align-self="center" cols="4">
                            <v-label>HPS</v-label>
                            <v-btn icon color="green" @click.prevent="tenderLib.getFileDownloadLink(form.tender.id, 'HPS', form.tender.fileHPS, false)"><v-icon>get_app</v-icon></v-btn>
                        </v-col>
                    </v-row>
                    <!-- File KAK -->
                    <v-row dense>
                        <v-col v-if="form.tender.fileKAK === ''" align-self="center" cols="4"> <span class="red--text">* KAK belum dilampirkan</span> </v-col>
                        <v-col v-else align-self="center" cols="4">
                            <v-label>KAK</v-label>
                            <v-btn icon color="green" @click.prevent="tenderLib.getFileDownloadLink(form.tender.id, 'KAK', form.tender.fileKAK, false)"><v-icon>get_app</v-icon></v-btn>
                        </v-col>
                    </v-row>
                    <!-- File Rancangan Kontrak -->
                    <v-row dense>
                        <v-col v-if="form.tender.fileRancanganKontrak === ''" align-self="center" cols="4"> <span class="red--text">* Rancangan kontrak belum dilampirkan</span> </v-col>
                        <v-col v-else align-self="center" cols="4">
                            <v-label>Rancangan Kontrak</v-label>
                            <v-btn icon color="green" @click.prevent="tenderLib.getFileDownloadLink(form.tender.id, 'RancanganKontrak', form.tender.fileRancanganKontrak, false)"><v-icon>get_app</v-icon></v-btn>
                        </v-col>
                    </v-row>
                    <!-- File Info Lain -->
                    <v-row dense>
                        <v-col v-if="form.tender.fileInfoLain === ''" align-self="center" cols="4"> <span class="red--text">* Info lain belum dilampirkan</span> </v-col>
                        <v-col v-else align-self="center" cols="4">
                            <v-label>Info Lain</v-label>
                            <v-btn icon color="green" @click.prevent="tenderLib.getFileDownloadLink(form.tender.id, 'InfoLain', form.tender.fileInfoLain, false)"><v-icon>get_app</v-icon></v-btn>
                        </v-col>
                    </v-row>


                    <!-- TENDER -->
                    <v-row class="blue-grey" dense> 
                        <v-col> <v-subheader>Tender</v-subheader> </v-col> 
                    </v-row>
                    <v-row dense> 
                        <v-col> <v-autocomplete v-model="form.tender.kbli" :items="selectionKBLI" label="KBLI" :rules="[form.rules.required]" :readonly="!form.isEditing" /> </v-col> 
                    </v-row>
                    <v-row dense> 
                        <v-col cols="6"> <v-autocomplete v-model="form.tender.jenisPengadaan" :items="selectionJenisPengadaan" label="Jenis Pengadaan" :rules="[form.rules.required]" :readonly="!form.isEditing" /> </v-col> 
                    </v-row>
                    <v-row dense> 
                        <v-col cols="6"> <v-autocomplete v-model="form.tender.metodePemilihan" :items="selectionMetodePemilihan" label="Metode Pemilihan" :rules="[form.rules.required]" :readonly="!form.isEditing" /> </v-col> 
                    </v-row>
                    <v-row dense> 
                        <v-col cols="6"> <v-autocomplete v-model="form.tender.metodeKualifikasi" :items="selectionMetodeKualifikasi" label="Metode Kualifikasi" :rules="[form.rules.required]" :readonly="!form.isEditing" /> </v-col> 
                    </v-row>
                    <v-row dense> 
                        <v-col cols="6"> <v-autocomplete v-model="form.tender.metodeEvaluasi" :items="selectionMetodeEvaluasi" label="Metode Evaluasi" :rules="[form.rules.required]" :readonly="!form.isEditing" /> </v-col> 
                    </v-row>
                    <v-row dense>
                        <v-col cols="6"> <v-autocomplete v-model="form.tender.pemenang" :items="selectionPemenang" label="Pemenang" :rules="[form.rules.required]" :readonly="!form.isEditing" /> </v-col>
                    </v-row>

                    <!-- File Dokumen Pemilihan -->
                    <v-row dense>
                        <v-col v-if="form.tender.fileDokumenPemilihan === ''" align-self="center" cols="4"> <span class="red--text">* Dokumen pemilihan belum dilampirkan</span> </v-col>
                        <v-col v-else align-self="center" cols="4">
                            <v-label>Dokumen Pemilihan</v-label>
                            <v-btn icon color="green" @click.prevent="tenderLib.getFileDownloadLink(form.tender.id, 'DokumenPemilihan', form.tender.fileDokumenPemilihan, false)"><v-icon>get_app</v-icon></v-btn>
                        </v-col>
                        <v-col cols="4"> <v-file-input v-if="form.isEditing" v-model="form.uploadFileDokumenPemilihan" label="Upload" dense /> </v-col>
                    </v-row>
                    <!-- File Persyaratan Kualifikasi -->
                    <v-row dense>
                        <v-col v-if="form.tender.filePersyaratanKualifikasi === ''" align-self="center" cols="4"> <span class="red--text">* Persyaratan kualifikasi belum dilampirkan</span> </v-col>
                        <v-col v-else align-self="center" cols="4">
                            <v-label>Persyaratan Kualifikasi</v-label>
                            <v-btn icon color="green" @click.prevent="tenderLib.getFileDownloadLink(form.tender.id, 'PersyaratanKualifikasi', form.tender.filePersyaratanKualifikasi, false)"><v-icon>get_app</v-icon></v-btn>
                        </v-col>
                        <v-col cols="4"> <v-file-input v-if="form.isEditing" v-model="form.uploadFilePersyaratanKualifikasi" label="Upload" dense /> </v-col>
                    </v-row>
                    <!-- File Persyaratan Teknis -->
                    <v-row dense>
                        <v-col v-if="form.tender.filePersyaratanTeknis === ''" align-self="center" cols="4"> <span class="red--text">* Persyaratan teknis belum dilampirkan</span> </v-col>
                        <v-col v-else align-self="center" cols="4">
                            <v-label>Persyaratan Teknis</v-label>
                            <v-btn icon color="green" @click.prevent="tenderLib.getFileDownloadLink(form.tender.id, 'PersyaratanTeknis', form.tender.filePersyaratanTeknis, false)"><v-icon>get_app</v-icon></v-btn>
                        </v-col>
                        <v-col cols="4"> <v-file-input v-if="form.isEditing" v-model="form.uploadFilePersyaratanTeknis" label="Upload" dense /> </v-col>
                    </v-row>
                    <!-- File Persyaratan Keuangan -->
                    <v-row dense>
                        <v-col v-if="form.tender.filePersyaratanKeuangan === ''" align-self="center" cols="4"> <span class="red--text">* Persyaratan keuangan belum dilampirkan</span> </v-col>
                        <v-col v-else align-self="center" cols="4">
                            <v-label>Persyaratan Keuangan</v-label>
                            <v-btn icon color="green" @click.prevent="tenderLib.getFileDownloadLink(form.tender.id, 'PersyaratanKeuangan', form.tender.filePersyaratanKeuangan, false)"><v-icon>get_app</v-icon></v-btn>
                        </v-col>
                        <v-col cols="4"> <v-file-input v-if="form.isEditing" v-model="form.uploadFilePersyaratanKeuangan" label="Upload" dense /> </v-col>
                    </v-row>
                    <!-- File Dokumen Penawaran Teknis -->
                    <v-row dense>
                        <v-col v-if="form.tender.fileDokumenPenawaranTeknis === ''" align-self="center" cols="4"> <span class="red--text">* Penawaran Teknis belum dilampirkan</span> </v-col>
                        <v-col v-else align-self="center" cols="4">
                            <v-label>Penawaran Teknis</v-label>
                            <v-btn icon color="green" @click.prevent="tenderLib.getFileDownloadLink(form.tender.id, 'PenawaranTeknis', form.tender.fileDokumenPenawaranTeknis, false)"><v-icon>get_app</v-icon></v-btn>
                        </v-col>
                        <v-col cols="4"> <v-file-input v-if="form.isEditing" v-model="form.uploadFileDokumenPenawaranTeknis" label="Upload" dense /> </v-col>
                    </v-row>
                    <!-- File Dokumen Tender -->
                    <v-row dense>
                        <v-col v-if="form.tender.fileDokumenTender === ''" align-self="center" cols="4"> <span class="red--text">* Dokumen Tender belum dilampirkan</span> </v-col>
                        <v-col v-else align-self="center" cols="4">
                            <v-label>Dokumen Tender</v-label>
                            <v-btn icon color="green" @click.prevent="tenderLib.getFileDownloadLink(form.tender.id, 'DokumenTender', form.tender.fileDokumenTender, false)"><v-icon>get_app</v-icon></v-btn>
                        </v-col>
                        <v-col cols="4"> <v-file-input v-if="form.isEditing" v-model="form.uploadFileDokumenTender" label="Upload" dense /> </v-col>
                    </v-row>


                    <!-- JADWAL -->
                    <v-row class="blue-grey" dense>
                        <v-col> <v-subheader>Jadwal</v-subheader> </v-col>
                    </v-row>
                    <v-row dense>
                        <v-col cols="4" align-self="center"> <p>Pengumuman</p> </v-col>
                        <v-col> <component-datetime-picker v-model="form.tender.tglPengumumanAwal" label="Mulai" :rules="[form.rules.required]" /> </v-col>
                        <v-col> <component-datetime-picker v-model="form.tender.tglPengumumanAkhir" label="Selesai" :rules="[form.rules.required]" /> </v-col>
                        <!--
                        <v-col> <component-text-date-picker :date-value="form.tender.tglPengumumanAwal" label="Mulai" :rulesRequired="[form.rules.required]" @changed="form.tender.tglPengumumanAwal = $event" /> </v-col>
                        <v-col> <component-text-date-picker :date-value="form.tender.tglPengumumanAkhir" label="Selesai" :rulesRequired="[form.rules.required]" @changed="form.tender.tglPengumumanAkhir = $event" /> </v-col>
                        -->
                    </v-row>
                    <v-row dense>
                        <v-col cols="4"> <v-label>Download Dokumen Pemilihan</v-label> </v-col>
                        <v-col> <component-datetime-picker v-model="form.tender.tglDownloadDokumenPemilihanAwal" label="Mulai" :rules="[form.rules.required]" /> </v-col>
                        <v-col> <component-datetime-picker v-model="form.tender.tglDownloadDokumenPemilihanAkhir" label="Selesai" :rules="[form.rules.required]" /> </v-col>
                        <!--
                        <v-col> <component-text-date-picker :date-value="form.tender.tglDownloadDokumenPemilihanAwal" label="Mulai" :rulesRequired="[form.rules.required]" @changed="form.tender.tglDownloadDokumenPemilihanAwal = $event" /> </v-col>
                        <v-col> <component-text-date-picker :date-value="form.tender.tglDownloadDokumenPemilihanAkhir" label="Selesai" :rulesRequired="[form.rules.required]" @changed="form.tender.tglDownloadDokumenPemilihanAkhir = $event" /> </v-col>
                        -->
                    </v-row>
                    <v-row dense>
                        <v-col cols="4"> <v-label>Pemberian Penjelasan</v-label> </v-col>
                        <v-col> <component-datetime-picker v-model="form.tender.tglPemberianPenjelasanAwal" label="Mulai" :rules="[form.rules.required]" /> </v-col>
                        <v-col> <component-datetime-picker v-model="form.tender.tglPemberianPenjelasanAkhir" label="Selesai" :rules="[form.rules.required]" /> </v-col>
                        <!--
                        <v-col> <component-text-date-picker :date-value="form.tender.tglPemberianPenjelasanAwal" label="Mulai" :rulesRequired="[form.rules.required]" @changed="form.tender.tglPemberianPenjelasanAwal = $event" /> </v-col>
                        <v-col> <component-text-date-picker :date-value="form.tender.tglPemberianPenjelasanAkhir" label="Selesai" :rulesRequired="[form.rules.required]" @changed="form.tender.tglPemberianPenjelasanAkhir = $event" /> </v-col>
                        -->
                    </v-row>
                    <v-row dense>
                        <v-col cols="4"> <v-label>Upload Dokumen Penawaran</v-label> </v-col>
                        <v-col> <component-datetime-picker v-model="form.tender.tglUploadDokumenPenawaranAwal" label="Mulai" :rules="[form.rules.required]" /> </v-col>
                        <v-col> <component-datetime-picker v-model="form.tender.tglUploadDokumenPenawaranAkhir" label="Selesai" :rules="[form.rules.required]" /> </v-col>
                        <!--
                        <v-col> <component-text-date-picker :date-value="form.tender.tglUploadDokumenPenawaranAwal" label="Mulai" :rulesRequired="[form.rules.required]" @changed="form.tender.tglUploadDokumenPenawaranAwal = $event" /> </v-col>
                        <v-col> <component-text-date-picker :date-value="form.tender.tglUploadDokumenPenawaranAkhir" label="Selesai" :rulesRequired="[form.rules.required]" @changed="form.tender.tglUploadDokumenPenawaranAkhir = $event" /> </v-col>
                        -->
                    </v-row>
                    <v-row dense>
                        <v-col cols="4"> <v-label>Pembukaan Dokumen Penawaran</v-label> </v-col>
                        <v-col> <component-datetime-picker v-model="form.tender.tglPembukaanDokumenPenawaranAwal" label="Mulai" :rules="[form.rules.required]" /> </v-col>
                        <v-col> <component-datetime-picker v-model="form.tender.tglPembukaanDokumenPenawaranAkhir" label="Selesai" :rules="[form.rules.required]" /> </v-col>
                        <!--
                        <v-col> <component-text-date-picker :date-value="form.tender.tglPembukaanDokumenPenawaranAwal" label="Mulai" :rulesRequired="[form.rules.required]" @changed="form.tender.tglPembukaanDokumenPenawaranAwal = $event" /> </v-col>
                        <v-col> <component-text-date-picker :date-value="form.tender.tglPembukaanDokumenPenawaranAkhir" label="Selesai" :rulesRequired="[form.rules.required]" @changed="form.tender.tglPembukaanDokumenPenawaranAkhir = $event" /> </v-col>
                        -->
                    </v-row>

                    <!-- PRAKUALIFIKASI -->
                    <template v-if="form.tender.metodeKualifikasi === 'P'">
                        <v-row dense>
                            <v-col cols="4"> <v-label>Upload Dokumen Teknis</v-label> </v-col>
                            <v-col> <component-datetime-picker v-model="form.tender.tglUploadDokumenTeknisAwal" label="Mulai" :rules="[form.rules.required]" /> </v-col>
                            <v-col> <component-datetime-picker v-model="form.tender.tglUploadDokumenTeknisAkhir" label="Selesai" :rules="[form.rules.required]" /> </v-col>
                            <!--
                            <v-col> <component-text-date-picker :date-value="form.tender.tglUploadDokumenTeknisAwal" label="Mulai" :rulesRequired="[form.rules.required]" @changed="form.tender.tglUploadDokumenTeknisAwal = $event" /> </v-col>
                            <v-col> <component-text-date-picker :date-value="form.tender.tglUploadDokumenTeknisAkhir" label="Selesai" :rulesRequired="[form.rules.required]" @changed="form.tender.tglUploadDokumenTeknisAkhir = $event" /> </v-col>
                            -->
                        </v-row>
                        <v-row dense>
                            <v-col cols="4"> <v-label>Pembukaan Dokumen Teknis</v-label> </v-col>
                            <v-col> <component-datetime-picker v-model="form.tender.tglPembukaanDokumenTeknisAwal" label="Mulai" :rules="[form.rules.required]" /> </v-col>
                            <v-col> <component-datetime-picker v-model="form.tender.tglPembukaanDokumenTeknisAkhir" label="Selesai" :rules="[form.rules.required]" /> </v-col>
                            <!--
                            <v-col> <component-text-date-picker :date-value="form.tender.tglPembukaanDokumenTeknisAwal" label="Mulai" :rulesRequired="[form.rules.required]" @changed="form.tender.tglPembukaanDokumenTeknisAwal = $event" /> </v-col>
                            <v-col> <component-text-date-picker :date-value="form.tender.tglPembukaanDokumenTeknisAkhir" label="Selesai" :rulesRequired="[form.rules.required]" @changed="form.tender.tglPembukaanDokumenTeknisAkhir = $event" /> </v-col>
                            -->
                        </v-row>
                    </template>
                    <!-- -------------- -->

                    <v-row dense>
                        <v-col cols="4"> <v-label>Evaluasi</v-label> </v-col>
                        <v-col> <component-datetime-picker v-model="form.tender.tglEvaluasiAwal" label="Mulai" :rules="[form.rules.required]" /> </v-col>
                        <v-col> <component-datetime-picker v-model="form.tender.tglEvaluasiAkhir" label="Selesai" :rules="[form.rules.required]" /> </v-col>
                        <!--
                        <v-col> <component-text-date-picker :date-value="form.tender.tglEvaluasiAwal" label="Mulai" :rulesRequired="[form.rules.required]" @changed="form.tender.tglEvaluasiAwal = $event" /> </v-col>
                        <v-col> <component-text-date-picker :date-value="form.tender.tglEvaluasiAkhir" label="Selesai" :rulesRequired="[form.rules.required]" @changed="form.tender.tglEvaluasiAkhir = $event" /> </v-col>
                        -->
                    </v-row>
                    <v-row dense>
                        <v-col cols="4"> <v-label>Pembuktian Kualifikasi</v-label> </v-col>
                        <v-col> <component-datetime-picker v-model="form.tender.tglPembuktianKualifikasiAwal" label="Mulai" :rules="[form.rules.required]" /> </v-col>
                        <v-col> <component-datetime-picker v-model="form.tender.tglPembuktianKualifikasiAkhir" label="Selesai" :rules="[form.rules.required]" /> </v-col>
                        <!--
                        <v-col> <component-text-date-picker :date-value="form.tender.tglPembuktianKualifikasiAwal" label="Mulai" :rulesRequired="[form.rules.required]" @changed="form.tender.tglPembuktianKualifikasiAwal = $event" /> </v-col>
                        <v-col> <component-text-date-picker :date-value="form.tender.tglPembuktianKualifikasiAkhir" label="Selesai" :rulesRequired="[form.rules.required]" @changed="form.tender.tglPembuktianKualifikasiAkhir = $event" /> </v-col>
                        -->
                    </v-row>
                    <v-row dense>
                        <v-col cols="4"> <v-label>Penetapan Pemenang</v-label> </v-col>
                        <v-col> <component-datetime-picker v-model="form.tender.tglPenetapanPemenangAwal" label="Mulai" :rules="[form.rules.required]" /> </v-col>
                        <v-col> <component-datetime-picker v-model="form.tender.tglPenetapanPemenangAkhir" label="Selesai" :rules="[form.rules.required]" /> </v-col>
                        <!--
                        <v-col> <component-text-date-picker :date-value="form.tender.tglPenetapanPemenangAwal" label="Mulai" :rulesRequired="[form.rules.required]" @changed="form.tender.tglPenetapanPemenangAwal = $event" /> </v-col>
                        <v-col> <component-text-date-picker :date-value="form.tender.tglPenetapanPemenangAkhir" label="Selesai" :rulesRequired="[form.rules.required]" @changed="form.tender.tglPenetapanPemenangAkhir = $event" /> </v-col>
                        -->
                    </v-row>
                    <v-row dense>
                        <v-col cols="4"> <v-label>Pengumuman Pemenang</v-label> </v-col>
                        <v-col> <component-datetime-picker v-model="form.tender.tglPengumumanPemenangAwal" label="Mulai" :rules="[form.rules.required]" /> </v-col>
                        <v-col> <component-datetime-picker v-model="form.tender.tglPengumumanPemenangAkhir" label="Selesai" :rules="[form.rules.required]" /> </v-col>
                        <!--
                        <v-col> <component-text-date-picker :date-value="form.tender.tglPengumumanPemenangAwal" label="Mulai" :rulesRequired="[form.rules.required]" @changed="form.tender.tglPengumumanPemenangAwal = $event" /> </v-col>
                        <v-col> <component-text-date-picker :date-value="form.tender.tglPengumumanPemenangAkhir" label="Selesai" :rulesRequired="[form.rules.required]" @changed="form.tender.tglPengumumanPemenangAkhir = $event" /> </v-col>
                        -->
                    </v-row>
                    <v-row dense>
                        <v-col cols="4"> <v-label>Masa Sanggah</v-label> </v-col>
                        <v-col> <component-datetime-picker v-model="form.tender.tglMasaSanggahAwal" label="Mulai" :rules="[form.rules.required]" /> </v-col>
                        <v-col> <component-datetime-picker v-model="form.tender.tglMasaSanggahAkhir" label="Selesai" :rules="[form.rules.required]" /> </v-col>
                        <!--
                        <v-col> <component-text-date-picker :date-value="form.tender.tglMasaSanggahAwal" label="Mulai" :rulesRequired="[form.rules.required]" @changed="form.tender.tglMasaSanggahAwal = $event" /> </v-col>
                        <v-col> <component-text-date-picker :date-value="form.tender.tglMasaSanggahAkhir" label="Selesai" :rulesRequired="[form.rules.required]" @changed="form.tender.tglMasaSanggahAkhir = $event" /> </v-col>
                        -->
                    </v-row>
                    <v-row dense>
                        <v-col cols="4"> <v-label>Surat Penunjukan Penyedia</v-label> </v-col>
                        <v-col> <component-datetime-picker v-model="form.tender.tglSuratPenunjukanPenyediaAwal" label="Mulai" :rules="[form.rules.required]" /> </v-col>
                        <v-col> <component-datetime-picker v-model="form.tender.tglSuratPenunjukanPenyediaAkhir" label="Selesai" :rules="[form.rules.required]" /> </v-col>
                        <!--
                        <v-col> <component-text-date-picker :date-value="form.tender.tglSuratPenunjukanPenyediaAwal" label="Mulai" :rulesRequired="[form.rules.required]" @changed="form.tender.tglSuratPenunjukanPenyediaAwal = $event" /> </v-col>
                        <v-col> <component-text-date-picker :date-value="form.tender.tglSuratPenunjukanPenyediaAkhir" label="Selesai" :rulesRequired="[form.rules.required]" @changed="form.tender.tglSuratPenunjukanPenyediaAkhir = $event" /> </v-col>
                        -->
                    </v-row>
                    <v-row dense>
                        <v-col cols="4"> <v-label>Penandatanganan Kontrak</v-label> </v-col>
                        <v-col> <component-datetime-picker v-model="form.tender.tglPenandatangananKontrakAwal" label="Mulai" :rules="[form.rules.required]" /> </v-col>
                        <v-col> <component-datetime-picker v-model="form.tender.tglPenandatangananKontrakAkhir" label="Selesai" :rules="[form.rules.required]" /> </v-col>
                        <!--
                        <v-col> <component-text-date-picker :date-value="form.tender.tglPenandatangananKontrakAwal" label="Mulai" :rulesRequired="[form.rules.required]" @changed="form.tender.tglPenandatangananKontrakAwal = $event" /> </v-col>
                        <v-col> <component-text-date-picker :date-value="form.tender.tglPenandatangananKontrakAkhir" label="Selesai" :rulesRequired="[form.rules.required]" @changed="form.tender.tglPenandatangananKontrakAkhir = $event" /> </v-col>
                        -->
                    </v-row>


                    <!-- PENYEDIA -->
                    <template v-if="form.tender.metodePemilihan === 'P'">
                        <v-row class="blue-grey" dense>
                            <v-col> <v-subheader>Penunjukan Langsung</v-subheader> </v-col>
                        </v-row>
                        <v-row>
                            <v-col> <v-btn color="green" depressed small>Tambah Penyedia</v-btn> </v-col>
                        </v-row>
                    </template>


                </v-container>
            </v-card>


            <!-- ACTIONS -->
            <v-card class="grey">
                <v-card-actions>
                    <v-btn color="cyan" @click="closeForm()">Tutup</v-btn>
                    <v-btn v-if="form.isEditing" color="green" @click="submitForm(false)" :disabled="form.isSubmitting">Simpan</v-btn>
                    <v-btn v-if="shouldShowConfirmButton()" color="red" @click="submitForm(true)" :disabled="form.isSubmitting">Konfirmasi</v-btn>
                </v-card-actions>
            </v-card>

        </v-form>
        </v-dialog>

    </div>
</template>



<script>

const API_URL = process.env.VUE_APP_ROOT_API
const axios = require('axios').default;
import { rules as Rules } from "./../../lib/rules";
import { itemsKbli, SumberDana, getValueItem, provinsi2, kabKota2, itemsJenisPengadaan, itemsMetodePemilihan, itemsMetodeKualifikasi, itemsMetodeEvaluasi, itemsJenisKontrak, itemsPemenang } from "./../../lib/viewLib";
import { TenderLib } from "./../../lib/tenderLib";
//import TextFieldDatePicker from "@/components/TextFieldDatePicker.vue";
import DateTimePicker from "./../../components/DateTimePicker.vue";



export default {
    components: {
        //"component-text-date-picker": TextFieldDatePicker,
        "component-datetime-picker": DateTimePicker
    },


    data() {
        return {
            selectionKBLI: itemsKbli,
            selectionJenisPengadaan: itemsJenisPengadaan,
            selectionMetodePemilihan: itemsMetodePemilihan,
            selectionMetodeKualifikasi: itemsMetodeKualifikasi,
            selectionMetodeEvaluasi: itemsMetodeEvaluasi,
            selectionJenisKontrak: itemsJenisKontrak,
            selectionPemenang: itemsPemenang,
            tenderLib: TenderLib,

            table:
            {
                headers: 
                [
                    { text: "Nama Paket", value: "nama" },
                    { text: "Status", value: "status" },
                    { text: "Actions", value: "actions" }
                ],
                items: []
            },

            form: 
            {
                tender: TenderLib.resetTender(),
                ListSumberDana: [],
                ListLokasiKerja: [],
                totalPagu: 0,
                uploadFileDokumenPemilihan: null,
                uploadFilePersyaratanKualifikasi: null,
                uploadFilePersyaratanTeknis: null,
                uploadFilePersyaratanKeuangan: null,
                uploadFileDokumenPenawaranTeknis: null,
                uploadFileDokumenTender: null,
                isShowing: false,
                isEditing: false,
                isDeleting: false,
                isSubmitting: false,
                isValid: false,
                rules: 
                {
                    required: Rules.required,
                }
            }
        }
    },

    
    created() {
        // Get all paket tender yg sudah di-approve oleh PPK (A0)
        axios.get(`${API_URL}/api/tender/panitia`)
        .then( (response) => {
            console.log("List paket: ", response.data);
            this.table.items = response.data;
        })
        .catch( (error) => {
            console.error(error);
        });
    },


    methods: {   
        GetSumberDanaCap(val) {
            return getValueItem(SumberDana, val)
        },

        GetProvinsiCap(val) {
            const el = kabKota2.find(el => el.value === val)
            return getValueItem(provinsi2, el.prov)
        },

        GetKotaCap(val) {
            return getValueItem(kabKota2, val)
        },

        refreshData() {
            this.form.ListSumberDana = [];
            this.form.ListLokasiKerja = [];
                
            this.form.tender.listPaket.forEach(element => {
                element.ListSumberDana.forEach(dana => {
                    this.form.ListSumberDana.push(dana);
                });

                element.ListLokasiKerja.forEach(lokasi => {
                    this.form.ListLokasiKerja.push(lokasi);
                });
            });

            // Calculate total pagu
            this.form.totalPagu = 0;
            this.form.ListSumberDana.forEach(dana => {
                this.form.totalPagu += Number(dana.pagu);
            });
        },


        resetForm() {
            this.form.tender = TenderLib.resetTender();
            this.form.ListSumberDana = [];
            this.form.ListLokasiKerja = [];
            this.form.totalPagu = 0;
            this.form.uploadFileDokumenPemilihan = null;
            this.form.uploadFilePersyaratanKualifikasi = null;
            this.form.uploadFilePersyaratanTeknis = null;
            this.form.uploadFilePersyaratanKeuangan = null;
            this.form.uploadFileDokumenPenawaranTeknis = null;
            this.form.uploadFileDokumenTender = null;
        },


        async openForm(tender, bIsReadOnly) {
            if (tender == null) return;

            this.resetForm();
            this.form.tender = tender;

            await axios.get(`${API_URL}/api/tender/paket/${tender.id}`)
            .then( (response) => {
                this.form.tender.listPaket = response.data;
                this.refreshData();
            })
            .catch( (error) => {
                console.error(error);
            });

            this.form.isShowing = true;
            this.form.isEditing = !bIsReadOnly;
        },


        closeForm() {
            this.form.isShowing = false;
            this.form.isEditing = false;
            this.form.isDeleting = false;
            this.form.isSubmitting = false;
        },


        deleteConfirmation(tender) {
            if (tender)
            {
                this.form.tender = tender;
                this.form.isDeleting = true;
            }
        },


        shouldShowConfirmButton() {
            return this.form.isEditing && this.form.tender.status === "D1";
            // TODO: Add user privilege
        },


        async submitForm(bIsApproval) {

            this.form.isSubmitting = true;
            this.$store.dispatch("displayProgBar");
            const tenderId = this.form.tender.id;

            if (this.form.isEditing)
            {
                if (!this.$refs.form.validate())
                {
                    this.form.isSubmitting = false;
                    this.$store.dispatch('closeProgBar');
                    return;
                }

                // APPROVAL
                if (bIsApproval)
                {
                    console.log("Submit form: Approve tender");
                    const newStatus = this.form.tender.metodePemilihan === 'P' ? "T0" : "T1";

                    await axios.put(`${API_URL}/api/tender/status/${tenderId}/${newStatus}`)
                    .then( (response) => {
                        console.log("Response Approval: ", response.data);
                        const index = this.table.items.findIndex(element => { return element.id === tenderId; });

                        if (index != -1)
                        {
                            this.table.items.splice(index, 1);
                        }

                        this.$store.dispatch('displayAlert', {
                            color: "success", 
                            message: `Tender dengan kode ${tenderId} berhasil di konfirmasi` 
                        });
                    })
                    .catch( (error) => {
                        console.error(error);

                        this.$store.dispatch('displayAlert', {
                            color: "error", 
                            message: `[${error.message}] Gagal konfirmasi tender dengan kode ${tenderId}` 
                        });
                    })
                    .finally( () => {
                        this.closeForm();
                        this.$store.dispatch('closeProgBar');
                    });
                }
                // CREATE/UPDATE
                else
                {
                    console.log("Submit form: Create tender");

                    let formData = new FormData();
                    formData.append("status", "D1");
                    formData.append("kbli", this.form.tender.kbli);
                    formData.append("jenisPengadaan", this.form.tender.jenisPengadaan);
                    formData.append("metodePemilihan", this.form.tender.metodePemilihan);
                    formData.append("metodeKualifikasi", this.form.tender.metodeKualifikasi);
                    formData.append("metodeEvaluasi", this.form.tender.metodeEvaluasi);
                    formData.append("pemenang", this.form.tender.pemenang);
                    formData.append("tglPengumumanAwal", this.form.tender.tglPengumumanAwal);
                    formData.append("tglPengumumanAkhir", this.form.tender.tglPengumumanAkhir);
                    formData.append("tglDownloadDokumenPemilihanAwal", this.form.tender.tglDownloadDokumenPemilihanAwal);
                    formData.append("tglDownloadDokumenPemilihanAkhir", this.form.tender.tglDownloadDokumenPemilihanAkhir);
                    formData.append("tglPemberianPenjelasanAwal", this.form.tender.tglPemberianPenjelasanAwal);
                    formData.append("tglPemberianPenjelasanAkhir", this.form.tender.tglPemberianPenjelasanAkhir);
                    formData.append("tglUploadDokumenPenawaranAwal", this.form.tender.tglUploadDokumenPenawaranAwal);
                    formData.append("tglUploadDokumenPenawaranAkhir", this.form.tender.tglUploadDokumenPenawaranAkhir);
                    formData.append("tglPembukaanDokumenPenawaranAwal", this.form.tender.tglPembukaanDokumenPenawaranAwal);
                    formData.append("tglPembukaanDokumenPenawaranAkhir", this.form.tender.tglPembukaanDokumenPenawaranAkhir);

                    // Prakualifikasi 
                    if (this.form.tender.metodeKualifikasi === 'P')
                    {
                        formData.append("tglUploadDokumenTeknisAwal", this.form.tender.tglUploadDokumenTeknisAwal);
                        formData.append("tglUploadDokumenTeknisAkhir", this.form.tender.tglUploadDokumenTeknisAkhir);
                        formData.append("tglPembukaanDokumenTeknisAwal", this.form.tender.tglPembukaanDokumenTeknisAwal);
                        formData.append("tglPembukaanDokumenTeknisAkhir", this.form.tender.tglPembukaanDokumenTeknisAkhir);
                    }

                    formData.append("tglEvaluasiAwal", this.form.tender.tglEvaluasiAwal);
                    formData.append("tglEvaluasiAkhir", this.form.tender.tglEvaluasiAkhir);
                    formData.append("tglPembuktianKualifikasiAwal", this.form.tender.tglPembuktianKualifikasiAwal);
                    formData.append("tglPembuktianKualifikasiAkhir", this.form.tender.tglPembuktianKualifikasiAkhir);
                    formData.append("tglPenetapanPemenangAwal", this.form.tender.tglPenetapanPemenangAwal);
                    formData.append("tglPenetapanPemenangAkhir", this.form.tender.tglPenetapanPemenangAkhir);
                    formData.append("tglPengumumanPemenangAwal", this.form.tender.tglPengumumanPemenangAwal);
                    formData.append("tglPengumumanPemenangAkhir", this.form.tender.tglPengumumanPemenangAkhir);
                    formData.append("tglMasaSanggahAwal", this.form.tender.tglMasaSanggahAwal);
                    formData.append("tglMasaSanggahAkhir", this.form.tender.tglMasaSanggahAkhir);
                    formData.append("tglSuratPenunjukanPenyediaAwal", this.form.tender.tglSuratPenunjukanPenyediaAwal);
                    formData.append("tglSuratPenunjukanPenyediaAkhir", this.form.tender.tglSuratPenunjukanPenyediaAkhir);
                    formData.append("tglPenandatangananKontrakAwal", this.form.tender.tglPenandatangananKontrakAwal);
                    formData.append("tglPenandatangananKontrakAkhir", this.form.tender.tglPenandatangananKontrakAkhir);

                    if (this.form.uploadFileDokumenPemilihan) formData.append("fileDokumenPemilihan", this.form.uploadFileDokumenPemilihan);
                    if (this.form.uploadFilePersyaratanKualifikasi) formData.append("filePersyaratanKualifikasi", this.form.uploadFilePersyaratanKualifikasi);
                    if (this.form.uploadFilePersyaratanTeknis) formData.append("filePersyaratanTeknis", this.form.uploadFilePersyaratanTeknis);
                    if (this.form.uploadFilePersyaratanKeuangan) formData.append("filePersyaratanKeuangan", this.form.uploadFilePersyaratanKeuangan);
                    if (this.form.uploadFileDokumenPenawaranTeknis) formData.append("fileDokumenPenawaranTeknis", this.form.uploadFileDokumenPenawaranTeknis);
                    if (this.form.uploadFileDokumenTender) formData.append("fileDokumenTender", this.form.uploadFileDokumenTender);

                    // Penunjukan langsung
                    if (this.form.tender.metodePemilihan === 'P')
                    {
                        formData.append("listPeserta", this.form.tender.listPeserta);
                    }

                    await axios.put(`${API_URL}/api/tender/proses/${tenderId}`, formData, { headers: { "Content-Type": "multipart/form-data" } })
                    .then( (response) => {
                        console.log("Response Create/Update: ", response.data);
                        const index = this.table.items.findIndex((element) => { return element.id === tenderId; });

                        if (index != -1)
                        {
                            this.table.items.splice(index, 1);
                            this.table.items.push(response.data);
                        }

                        this.$store.dispatch('displayAlert', {
                            color: "success", 
                            message: `Proses tender dengan kode ${tenderId} berhasil di-update` 
                        });
                    })
                    .catch( (error) => {
                        console.error(error);
                        this.$store.dispatch('displayAlert', {
                            color: "error", 
                            message: `[${error.message}] Gagal update proses tender ${tenderId}` 
                        });
                    })
                    .finally( () => {
                        this.closeForm();
                        this.$store.dispatch('closeProgBar');
                    });
                }
            }
            // DELETE (status dikembalikan ke [A0=Approve PPK] dan beberapa data dikosongkan, bukan delete record di-database)
            else if (this.form.isDeleting)
            {
                console.log("Submit form: DELETE");

                await axios.delete(`${API_URL}/api/tender/proses/${tenderId}`)
                .then( (response) => {
                    console.log("Response Delete: ", response.data);
                    const index = this.table.items.findIndex((element) => { return element.id === tenderId; });

                    if (index != -1)
                    {
                        this.table.items.splice(index, 1);
                        this.table.items.push(response.data);
                    }

                    this.$store.dispatch('displayAlert', {
                        color: "success", 
                        message: `Proses tender dengan kode ${tenderId} berhasil dihapus` 
                    });
                })
                .catch( (error) => {
                    console.error(error);
                    this.$store.dispatch('displayAlert', {
                        color: "error", 
                        message: `[${error.message}] Gagal menghapus proses tender ${tenderId}` 
                    });
                })
                .finally( () => {
                    this.closeForm();
                    this.$store.dispatch('closeProgBar');
                });
            }
        }

    }
}

</script>
